import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { toast } from 'react-toastify';

import { tabMenuType } from '@utils/types';
import { memberTabMenu } from '@lib/data';
import { userVar } from '@store/index';

import Main from '@components/layout/Main';
import SideBar, { TabItem, TabList, TabMenu } from '@components/layout/SideBar';
import { Wrapper } from '@components/styled/StyledComponents';

const Member = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { adminPermission } = useReactiveVar(userVar);

    useEffect(() => {
        if (adminPermission?.user === false) {
            toast.error('접근 권한이 없습니다.');
            navigate('/');
            return;
        }
    }, [adminPermission]);

    return (
        <Main title="회원 관리" subTitle="펫이닷 회원 관리">
            <Wrapper $minHeight="calc(100 vh - 80px - 138px)">
                {pathname.includes('detail') ? (
                    <SideBar GO_BACK />
                ) : (
                    <SideBar>
                        <TabList>
                            {memberTabMenu.map(
                                (list: tabMenuType, index: number) => (
                                    <TabItem
                                        key={`${index}-tab-${list.dataText}`}
                                        onClick={() => navigate(list.pathname)}
                                    >
                                        <TabMenu
                                            data-text={list.dataText}
                                            $active={pathname === list.pathname}
                                        />
                                    </TabItem>
                                )
                            )}
                        </TabList>
                    </SideBar>
                )}
                <Outlet />
            </Wrapper>
        </Main>
    );
};

export default Member;
